import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCmmkojVtFf7BEO1iDNUZpW4DRDYZIS7o8",
  authDomain: "cookieguard-pro-1fd39.firebaseapp.com",
  projectId: "cookieguard-pro-1fd39",
  storageBucket: "cookieguard-pro-1fd39.firebasestorage.app",
  messagingSenderId: "974529880480",
  appId: "1:974529880480:web:d2d262c97ba6ce178584c5",
  measurementId: "G-SBXNQ3TGNM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
export default app;